<template>
  <carousel
    v-if="plans.length > 0"
    :navText="['<div></div>', '<div></div>']"
    :responsive="{
      0: { items: 1, nav: true, dots: true, autoplay: true, startPosition: 0, margin: 0 },
    }"
  >
    <div
      class="item"
      style="position: relative"
      v-for="(plan, index) in plans"
      :key="index"
      :class="{ 'col-xl-5 col-lg-6 col-md-12 mx-auto': plans.length === 1 }"
    >
      <plan-card-single
        :plan="plan"
        :colour="colour"
        :identifier="generateUniqueId()"
        :mobile_form="mobile_form"
        :uniqueId="generateUniqueId()"
        :details="details"
      ></plan-card-single>
    </div>
  </carousel>
</template>

<script>
import PlanCardSingle from "./PlanCardSingle.vue";
import Carousel from "vue-owl-carousel/src/Carousel";

export default {
  components: {
    PlanCardSingle,
    Carousel,
  },

  props: {
    colour: {
      type: String,
    },
    mobile_form: {
      type: Object,
      required: true,
    },
    details: {
      type: Object,
      required: true,
    },
    uniqueId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      plans: [],

      loading: false,
    };
  },

  mounted() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    this.fetchData();
  },

  methods: {
    fetchData() {
      this.loading = true;
      axios
        .get(process.env.VUE_APP_SUPASMART_URL + "api/plans?site_id=" + process.env.VUE_APP_SITE_ID)
        .then((response) => {
          this.loading = false;
          this.plans = response.data.data;
        })

        .catch((error) => {
          this.loading = false;
          this.formStep = 1;
          console.error(error);
          if (errors.response.data.error) {
            this.serverErrors = [{ generic: errors.response.data.error }];
            return;
          }
          this.serverErrors = Object.entries(errors.response.data.errors).map((entry) => {
            return { [entry[0]]: entry[1] };
          });
          this.scrollToError();
        });
    },
    generateUniqueId() {
      return Math.random().toString(36).substring(2) + Date.now().toString(36);
    },
  },
};
</script>

<style lang="scss" scoped>
.plan-container {
  margin-top: 2rem;

  @media only screen and (min-width: 992px) {
    margin-top: 5rem;
  }
}

.owl-stage {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  @media only screen and (min-width: 880px) {
    justify-content: center;
  }
}

.plan-slider {
  height: 100%;
  position: relative;
}

.plan-sec .container-sm,
.plan-sec .container {
  text-align: center;

  h1 {
    margin: 1rem !important;
  }
}
</style>
